export const actionTypes = {
  "createCollaborator": "createCollaborator",
  "editCollaborator": "editCollaborator",
  "deleteCollaborator": "deleteCollaborator",
  "deleteMultipleCollaborator": "deleteMultipleCollaborator",
};

export const createEditCollaboratorErrors = (type) => {
  const error = {
    400: 'El correo no es válido o ya esta en uso.',
    404: 'No se encontró el colaborador',
    500: 'Falló al cargar la imagen'
  }

  return error[type]
}

export const deleteAndWelcomeEmailMessage = ({ title, data } = {}) => {
  const message = `${title}: 
    ${data.success === 0 ? '' : `exito:${data.success}, `}
    ${data.failed === 0 ? '' : `fallo:${data.failed}, `}
    ${data.skipped === 0 ? '' : `ignorados:${data.skipped}`}
  `
  return message
}


export const posibleIds = ({ id = 'Administrador' }) => {
  const posibleIds = {
    'Todos': 1,
    'Administrador': 1,
  }
  return posibleIds[id] ? 1 : posibleIds[id]
}

// consfirm constants
export const buttonsConfirmDelete = {
  ok: 'Si, Continuar',
  cancel: 'No, Cancelar',
}

export const deleteSingleConfirmInfo = {
  title: '¿Estas seguro que deseas eliminar este colaborador?',
  text: 'Este proceso es irreversible y no podrá recuperar la información',
}

export const deleteMultipleConfirmInfo = {
  title: '¿Estas seguro que deseas eliminar estos colaboradores?',
  text: 'Este proceso es irreversible y no podrá recuperar la información',
}